const NewsAggregatorTable = {
  ID: 'newsId',
  TIME: 'publicDate',
  TICKER: 'ticker',
  NEWS: 'newsTitle',
  SOURCE: 'sourceCode',
};

const CommonTable = {
  ID: 'newsId',
  TIME: 'publicDate',
  TICKER: 'ticker',
  NEWS: 'newsTitle',
  SOURCE: 'sourceCode',
  TYPE: 'newsCategoryCode',
  CONTRIBUTOR: 'fullName',
  RUMORS: 'newsTitle',
  TRUSTABILITY: 'trustAbility',
};

const AutoNewsTable = {
  ID: 'newsId',
  TIME: 'createDate',
  TICKER: 'ticker',
  NEWS: 'newsTitle',
  TYPE: 'newsCategoryCode',
};

const PremiumAnalysisTable = {
  ID: 'newsId',
  TIME: 'publicDate',
  TICKER: 'ticker',
  NEWS: 'newsTitle',
  SOURCE: 'sourceCode',
};

const MostRecentTable = {
  ID: 'newsId',
  TIME: 'publicDate',
  TICKER: 'ticker',
  NEWS: 'newsTitle',
  CONTRIBUTOR: 'sourceCode',
};

const MostPopularTable = {
  ID: 'newsId',
  TIME: 'publicDate',
  TICKER: 'ticker',
  NEWS: 'newsTitle',
  CONTRIBUTOR: 'fullName',
};

const RumorsTable = {
  ID: 'newsId',
  TIME: 'publicDate',
  TICKER: 'ticker',
  RUMORS: 'newsTitle',
  TRUSTABILITY: 'trustAbility',
};

const TAB_MAPPING = {
  1: 'aggregatorNewsData',
  2: 'autoNewsData',
  3: 'premiumAnalysisData', //fiintrade diary
  4: {
    1: 'mostRecentData',
    2: 'mostPopularData',
    3: 'contributorsData',
  },
  5: 'rumorsData',
};

const SOURCE_CODE = 'sourceCode';

export default {
  NewsAggregatorTable,
  AutoNewsTable,
  CommonTable,
  PremiumAnalysisTable,
  MostRecentTable,
  MostPopularTable,
  RumorsTable,
  TAB_MAPPING,
  SOURCE_CODE,
};
